import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { UnmappedPunchStatus } from '../interfaces/unmappedDevicePunch.interface';

// Task 5 (2026-09-11-closeout-onboarding-device) — read/assign/discard for device punches
// AttendanceSyncService held instead of dropping (unknown device user, or a device user not yet
// mapped). Mirrors device-user.service.ts's axios + AuthService pattern.
export const UnmappedDevicePunchService = {
    getGroups: async (
        page: number = 0,
        size: number = 10,
        deviceSerial?: string,
        search?: string,
        status: UnmappedPunchStatus = 'HELD'
    ) => {
        const institutionId = AuthService.getSelectedInstitution();
        const params: Record<string, string | number> = { page, size, status };
        if (deviceSerial && deviceSerial.trim()) params.deviceSerial = deviceSerial.trim();
        if (search && search.trim()) params.search = search.trim();
        const response = await axios.get(ENDPOINTS.UNMAPPED_DEVICE_PUNCH.GROUPS(institutionId), {
            params,
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    getCount: async () => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(ENDPOINTS.UNMAPPED_DEVICE_PUNCH.COUNT(institutionId), {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    getPunches: async (
        deviceSerial: string,
        deviceUserNumber: number,
        page: number = 0,
        size: number = 10,
        status: UnmappedPunchStatus = 'HELD'
    ) => {
        const institutionId = AuthService.getSelectedInstitution();
        const params: Record<string, string | number> = { deviceSerial, deviceUserNumber, status, page, size };
        const response = await axios.get(ENDPOINTS.UNMAPPED_DEVICE_PUNCH.PUNCHES(institutionId), {
            params,
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    assign: async (deviceSerial: string, deviceUserNumber: number, userId: string) => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.post(
            ENDPOINTS.UNMAPPED_DEVICE_PUNCH.ASSIGN(institutionId),
            { deviceSerial, deviceUserNumber, userId },
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    discard: async (deviceSerial: string, deviceUserNumber: number) => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.post(
            ENDPOINTS.UNMAPPED_DEVICE_PUNCH.DISCARD(institutionId),
            { deviceSerial, deviceUserNumber },
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    }
};
